import React from "react";
import { formatMoney } from "@shopify/theme-currency";
import { withCartContext } from "./cartContext.jsx";
import ProgressBar from "./progressBar.jsx";

const ShippingThreshold = ({ cartState, shipping }) => {
  if (!shipping) return null;

  const totalCartPrice = cartState.total_price / 100;
  const freeShippingPrice = shipping.threshold;
  const percentage = (totalCartPrice / freeShippingPrice) * 100;
  const priceAway = freeShippingPrice * 100 - cartState.total_price;

  return (
    <div className="mini-cart__shipping-threshold">
      <p className="mini-cart__shipping-threshold-text text-body-2">
        {priceAway > 0
          ? shipping.heading.replace("{{ amount }}", formatMoney(priceAway))
          : shipping.headingThresholdMet}
      </p>
      <ProgressBar progress={percentage} />
    </div>
  );
};

export default withCartContext(ShippingThreshold);
